import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Legacy single-space explorer URL → project-level "Folders" URL.
 *
 * Old:  /workspace/:workspaceId/explorer?projectId=<id>#folderPath=/<folderIds>/
 * New:  /project/:projectId/folders?projectId=<id>&spaceId=<workspaceId>#folderPath=/<folderIds>/
 */
const RedirectExplorerToFolders = () => {
  const { workspaceId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const projectId = searchParams.get("projectId");

  // Without a projectId we cannot build the /project/:projectId/folders path — fall back to the projects list.
  if (!projectId || !workspaceId) {
    return <Navigate to="/projects" replace />;
  }

  let folderIds = "";
  if (location.hash) {
    const decoded = decodeURIComponent(location.hash.replace(/^#/, "")); // "folderPath=/id1/id2/"
    const value = decoded.slice(decoded.indexOf("=") + 1); // "/id1/id2/"
    folderIds = value.split("/").filter(Boolean).join("/"); // "id1/id2"
  }
  searchParams.set("spaceId", workspaceId);
  const hash = folderIds ? `#folderPath=${encodeURIComponent(`/${folderIds}/`)}` : "";
  const to = `/project/${projectId}/folders?${searchParams.toString()}${hash}`;

  return <Navigate to={to} replace />;
};

export default RedirectExplorerToFolders;
